/** Application-wide display timezone. All date formatting uses this.
 *  Change this single value if the client moves to a different timezone. */
export const APP_TIMEZONE = 'America/New_York';
export const APP_LOCALE = 'en-US';
